import { useCallback, useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import { Contract } from 'web3-eth-contract'

import {
  getEarned,
  getPetEarned,
  getBpetEarned,
  getWeaponEarned,
  getTokenEarned,
  commonStakeERC721EarnERC20PendingToken,
  commonStakeERC721EarnBakePendingToken
} from '../../sushi/utils'

import { simpleStakeERC721EarnERC20PendingToken } from '../../sushi/simpleStakeERC721EarnERC20'
import { MINTTOKEN } from '../../constants/bakery'

// hooks
import useYam from './useYam'
import useBlock from './useBlock'
import { useActiveWeb3React } from '../'
import { NFTTYPE } from '../../constants/bakery/nft'

import { poolMasterContract } from '../../userType/poolMasterContract'

const useEarnings = (lpTokenAddress: string, tokenName?: string) => {
  const [balance, setBalance] = useState(new BigNumber(0))
  const { account } = useActiveWeb3React()
  const yam = useYam()
  const block = useBlock()
  let masterContract: Contract = poolMasterContract(yam, tokenName)
  let getEarn: any
  switch (tokenName) {
      case MINTTOKEN.PET:
        getEarn = getPetEarned
        break
      case MINTTOKEN.BPET:
        getEarn = getBpetEarned
        break
      case MINTTOKEN.WEAPON:
        getEarn = getWeaponEarned
        break
      case MINTTOKEN.BEST:
      case MINTTOKEN.WSOTE:
      case MINTTOKEN.SHIELD:
      case MINTTOKEN.TEN:
      case MINTTOKEN.BRY:
      case MINTTOKEN.DEFI100:
      case MINTTOKEN.DEFI100OLD:
      case MINTTOKEN.BANANA:
      case MINTTOKEN.PCWS:
      case MINTTOKEN.WAR:
      case MINTTOKEN.WAR2:
      case MINTTOKEN.DIESEL:
      case MINTTOKEN.MX:
      case MINTTOKEN.ALICE:
      case MINTTOKEN.DFY:
      case MINTTOKEN.GFX:
      case MINTTOKEN.XDITTO:
      case MINTTOKEN.SACT:
      case MINTTOKEN.PET3:
      case MINTTOKEN.HYFI:
      case MINTTOKEN.GINU:
      case MINTTOKEN.LEV:
      case MINTTOKEN.BONDLY:
      case MINTTOKEN.TCT:
      case MINTTOKEN.TKO:
      case MINTTOKEN.TKONFTSTAKE:
      case MINTTOKEN.BMONCNFTSTAKE:
      case MINTTOKEN.BMMNFTSTAKE:
      case MINTTOKEN.TOYNFTSTAKE:
      case MINTTOKEN.TKO2:
      case MINTTOKEN.BNRG:
      case MINTTOKEN.TSA:
      case MINTTOKEN.TLM:
      case MINTTOKEN.TLM2:
      case MINTTOKEN.TLM3:
      case MINTTOKEN.TLM4:
      case MINTTOKEN.BONDLY2:
      case NFTTYPE.GAMEBOX:
      case MINTTOKEN.TLM5:
      case MINTTOKEN.BAKEV2:
      case MINTTOKEN.WSG:
      case MINTTOKEN.DOGO:
      case MINTTOKEN.BETHMASTER:
      case MINTTOKEN.TOKAU:
      case MINTTOKEN.BAKEV2:
      case MINTTOKEN.EGG:
      case MINTTOKEN.NT:
      case MINTTOKEN.MONI:
      case MINTTOKEN.KXA:
      case MINTTOKEN.KALATA:
      case MINTTOKEN.DON:
      case MINTTOKEN.NBL:
        getEarn = getTokenEarned
        break
      default:
        getEarn = getEarned
  }

  const fetchBalance = useCallback(async () => {
    let balance = 0
    if (tokenName && [MINTTOKEN.TKONFTSTAKE, NFTTYPE.GAMEBOX, MINTTOKEN.BMONCNFTSTAKE].includes(tokenName)) {
      balance = await commonStakeERC721EarnERC20PendingToken(masterContract, lpTokenAddress, account)
    } else if (tokenName && [MINTTOKEN.TOYNFTSTAKE].includes(tokenName)) {
      balance = await simpleStakeERC721EarnERC20PendingToken(masterContract, account)
    } else if (tokenName && [MINTTOKEN.BMMNFTSTAKE].includes(tokenName)) {
      balance = await commonStakeERC721EarnBakePendingToken(masterContract, account)
    } else {
      balance = await getEarn(masterContract, lpTokenAddress, account)
    }
    setBalance(new BigNumber(balance))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, masterContract, yam])

  useEffect(() => {
    if (account && masterContract && yam) {
      fetchBalance()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, block, masterContract, setBalance, yam])

  return balance
}

export default useEarnings
